import { Tooltip, useMantineTheme } from '@mantine/core'
import { IconAlertCircleFilled, IconCircleCheckFilled } from '@tabler/icons-react'

interface StatusProps {
  status: number
}

const Status: React.FC<StatusProps> = ({ status }) => {
  const theme = useMantineTheme()

  return (
    <Tooltip label={status ? 'Success' : 'Failed'} withArrow>
      {status === 1 ? (
        <IconCircleCheckFilled size="20px" style={{ color: theme.colors.l1Primary[0] }} />
      ) : (
        <IconAlertCircleFilled size="20px" style={{ color: theme.colors.notification[0] }} />
      )}
    </Tooltip>
  )
}

export default Status
